import schoolSelectFilterConfig from './school-select-filter';

export default (
  { cityId },
  {
    optionFormat,
    getOptionsFn,
    provinceOptions,
    schoolOptions,
    useProvinceOnly
  }
) => {
  return [
    {
      if: useProvinceOnly,
      label: '学校所在地',
      component: 'ui-select',
      key: 'provinceId',
      value: '',
      attrOrProp: {
        options: provinceOptions,
        optionFormat,
        defaultLabel: '请选择省份',
        inside: true
      }
    },
    {
      if: !useProvinceOnly,
      label: '学校所在地',
      component: 'ui-multi-select',
      components: [
        {
          key: 'provinceId',
          value: '',
          options: provinceOptions,
          attrOrProp: {
            optionFormat,
            defaultLabel: '请选择省份',
            inside: true
          }
        },
        {
          key: 'cityId',
          value: '',
          options: (data) => getOptionsFn.city(data),
          attrOrProp: {
            optionFormat,
            defaultLabel: '请选择城市',
            inside: true
          }
        }
      ]
    },
    ...schoolSelectFilterConfig,
    ...(schoolOptions.length
      ? [
          {
            label: '学校',
            component: 'ui-radio-group',
            key: 'schoolId',
            value: '',
            attrOrProp: {
              optionFormat,
              options: schoolOptions
            }
          }
        ]
      : [
          {
            label: '学校',
            component: 'ui-readonly-item',
            key: 'noSchoolId',
            value: () => '无'
          }
        ])
  ];
};
